import { StaffRole, StaffRoleLevels } from "../types/Staff";

export const getSelectableRoles = (loggedUserRoleLevel: number) => {
    const roles: StaffRole[] = [];

    if (loggedUserRoleLevel >= StaffRoleLevels[StaffRole.EMPLOYEE]) roles.push(StaffRole.EMPLOYEE);
    if (loggedUserRoleLevel >= StaffRoleLevels[StaffRole.OWNER]) roles.push(StaffRole.OWNER);
    if (loggedUserRoleLevel >= StaffRoleLevels[StaffRole.ADMIN]) roles.push(StaffRole.ADMIN);

    return roles;
};
